import $http from '@/resource';
import utils from '@/utils';
import Cache from '@/cache';

const $api = {};


/**
 * 获取标签分类列表
 *
 * @date 2018-8-20 20:41:15
 *
 * @returns {Promise<any>}
 */
$api.getTagType = ()=>{
    const url = "company/tags";
    const promise = new Promise(resolve=>{
        $http.get(url).then(response=>{
            if (response.code === "200") {
                resolve(response.data);
            } else {
                utils.notice(response.msg, 'error');
            }
        });
    });
    return promise;
};

/**
 * 保存标签分类
 *
 * @param {object} data 待保存的数据
 *
 * @date 2018-8-20 20:58:06
 *
 * @returns {Promise<any>}
 */
$api.saveTagType = (data)=>{
    const url = "company/tags";
    const promise = new Promise(resolve=>{
        $http.put(url,data).then(response=>{
            // if (response.code === "200") {
                resolve(response);
            // } else {
            //     utils.notice(response.msg, 'error');
            // }
        });
    });
    return promise;
};

/**
 * 删除标签分类
 *
 * @param {string} id 标签分类id
 *
 * @date 2018-8-29 18:07:23
 *
 * @returns {Promise<any>}
 */
$api.deleteTagType = (id)=>{
    const url = "company/tags/"+id;
    const promise = new Promise(resolve=>{
        $http.delete(url).then(response=>{
            resolve(response);
        });
    });
    return promise;
};

/**
 * 获取所有标签
 *
 * @date 2018-8-21 09:02:35
 *
 * @returns {Promise<any>}
 */
$api.getTagList = ()=>{
    const url = "company/alltags";
    const promise = new Promise(resolve=>{
        $http.get(url).then(response=>{
            if (response.code === "200") {
                resolve(response.data);
            } else {
                utils.notice(response.msg, 'error');
            }
        });
    });
    return promise;
};

/**
 * 保存所有标签
 *
 * @param {object} data 待保存的数据
 *
 * @date 2018-8-21 13:52:27
 *
 * @returns {Promise<any>}
 */
$api.saveTagList = (data)=>{
    const url = "company/alltags";
    const promise = new Promise(resolve=>{
        $http.put(url,data).then(response=>{
            // if (response.code === "200") {
                resolve(response);
            // } else {
            //     utils.notice(response.msg, 'error');
            // }
        });
    });
    return promise;
};

/**
 * 删除标签
 *
 * @param {object} data 转移设置项内容
 *
 * @date 2018-8-29 20:10:27
 *
 * @returns {Promise<any>}
 */
$api.deleteTag = (data)=>{
    const url = "company/alltags";
    const promise = new Promise(resolve=>{
        $http.post(url,data).then(response=>{
            resolve(response);
        });
    });
    return promise;
};

export default $api;


// WEBPACK FOOTER //
// ./src/service/company/tag.js